// src/pages/ConsultationRecords.js
import { useState, useEffect } from "react";
import MedicalRecordsChiefComplaint from "../components/MedicalRecordsChiefComplaint";
import MedicalRecordScrollTable from "../components/MedicalRecordScrollTable";
import api from "../api";
import { useAuth } from "../auth/AuthContext";

function ConsultationRecords() {
  const { user } = useAuth() || {};
  const storedPatient = sessionStorage.getItem("patient");
  const patient = storedPatient ? JSON.parse(storedPatient) : null;
  const patientId = patient?.research_id || user?.id || "P010";
  const [consultationData, setConsultationData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchConsultation = async () => {
      try {
        const res = await api.get(`/v1/doctor/patient_consultation/${patientId}`);
        setConsultationData(res.data);
      } catch (err) {
        console.error("診察情報取得エラー:", err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    fetchConsultation();
  }, [patientId]);

  // === ローディング／エラー／データなし ===
  if (loading) return <p>読み込み中...</p>;
  if (error) return <p>データの取得に失敗しました。</p>;
  if (!consultationData) return <p>データがありません。</p>;

  // === データ展開 ===
  const {
    you_made_happy,
    concerning_symptoms,
    symptoms_duration,
    concerns_or_questions,
    past_consultation = [],
  } = consultationData ?? {};

  return (
    <div style={{ maxWidth: "1000px", margin: "0 auto" }}>
      <h1 style={{ marginBottom: "2rem" }}>主訴・診察履歴</h1>

      {/* === 主訴 === */}
      <h2 style={{ margin: "2rem 0 1rem" }}>主訴</h2>
      <MedicalRecordsChiefComplaint
        patientName={patientId}
        complaint={{
          you_made_happy,
          concerning_symptoms,
          symptoms_duration,
          concerns_or_questions,
        }}
      />

      {/* === 診察履歴 === */}
      <h2 style={{ margin: "2rem 0 1rem" }}>診察履歴</h2>
      <MedicalRecordScrollTable records={past_consultation} />
    </div>
  );
}

export default ConsultationRecords;
